export const typesPersons = [
  { label: 'Natural', value: 'N' },
  { label: 'Jurídica', value: 'J' }
]

export const enumTypesPersons = {
  NATURAL: 'N',
  LEGAL: 'J'
}

export const fakeDataSignature = [
  { label: "Api de firma", value: "Api de firma" },
  { label: "Portal de consulta", value: "Portal de consulta" },
  { label: "Portal completo", value: "Portal completo" }
]